export default "__VITE_ASSET__C_l74axM__"